import { OnDestroy, Injectable } from "@angular/core";
import Utils from "../../shared/utils";
import { WebShopService } from "../../services/webShop.service";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { IRemoteGroupCodeInfo, IRemoteOrderGroupEntryService, EntryGroupResult, RemoteGroupMember } from "./remoteOrderGroupEntry.facade";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { EntryStatus } from "../../services/IRemoteGroupOrderService";

@Injectable()
export class RemoteOrderGroupEntryService implements IRemoteOrderGroupEntryService, OnDestroy {
  constructor(private _webShopService: WebShopService
    , private _coreLogService: CoreLogService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _router: Router
  ) { }

  ngOnDestroy(): void { }

  /** Retrieve group information from the remote service */
  public async getGroupInfo(groupId: number): Promise<IRemoteGroupCodeInfo> {
    const me = this;
    const info = await me._remoteGroupOrderService.retrieveGroupInformation(groupId);
    const result: IRemoteGroupCodeInfo = {
      valid: true,
      location: info.HypCusNr,
      groupInfo: {
        groupId: info.Id,
        groupName: info.Name,
        groupCreator: info.Members[0].Name,
        selectedServiceTime: info.ServiceTimestamp,
        selectedOrderTime: info.OrderTimestamp,
        pickUpAddress: "dummy pickup address",
        groupDeliveryAddress: "dummy delivery address",
        orderType: info.PreOrderType.Variant,
      },
      isFull: info.Members.length >= info.MemberLimit,
    }

    return result;
  }

  /**  * Checks if the nickname is valid. The joinGroup function subsequently checks if the name is duplicated. */
  public async checkNickname(nickname: string): Promise<boolean> {
    const me = this;
    const check_nickname = nickname.toUpperCase().trim();
    if (check_nickname == "") {
      return false;
    }
    const webshopSetting = await me._webShopService.getWebshopSettingsDataModel();
    if (webshopSetting.name_blacklist) {
      const blacklisted_name = webshopSetting.name_blacklist.find((blacklist_name) => check_nickname.includes(blacklist_name.toUpperCase().trim()))
      if (blacklisted_name) {
        return false;
      }
    }
    return true;
  }

  /** Determines if the user is already a member of this group*/
  public async membershipStatus(groupId: number): Promise<RemoteGroupMember> {
    const me = this;
    const currentUserGroupId = me._remoteGroupOrderService.groupId;
    if (Utils.IsNull(currentUserGroupId) || currentUserGroupId <= 0) {
      return RemoteGroupMember.Not;
    } else if (currentUserGroupId === groupId) {
      return RemoteGroupMember.Yes;
    } else {
      return RemoteGroupMember.Unknown;
    }
  }

  public async joinGroup(nickname: string, location: number, group_name: string, groupId: number): Promise<EntryGroupResult> {
    const me = this;
    // Attempt to join the group
    const newPlace = await me._remoteGroupOrderService.joinGroup(groupId, nickname);
    if (newPlace.success) {
      me._router.navigate(["/remoteOrderGroupServiceSelector"]);
      return EntryGroupResult.Okay;
    }

    // Handle different failure statuses
    switch (newPlace.status) {
      case EntryStatus.GroupFull:
        return EntryGroupResult.GroupFull;
      case EntryStatus.WrongUserName:
        return EntryGroupResult.WrongUserName;
      case EntryStatus.Fail:
        return EntryGroupResult.Fail;
      case EntryStatus.Error:
        return EntryGroupResult.PlaceUndefined;
      default:
        me._coreLogService.error("GroupOrderInviteService.joinGroup", "unknown status", newPlace.status);
        return EntryGroupResult.Fail;
    }
  }

  public async tryReassignGuestToPreviousGroup(groupId: number): Promise<boolean> {
    const me = this;
    return me._remoteGroupOrderService.tryReassignGuestToPreviousGroup(groupId);
  }

}
